"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dateUtils_1 = require("../../dateUtils");
var comparisonEngine_1 = require("../../features/comparison/comparisonEngine");
var Accessor_1 = require("../../models/Accessor");
var EffectiveDefinition_1 = require("../../models/EffectiveDefinition");
exports.TimeShiftType = 'time-shift';
var isTimeShift = function (calc) {
    return calc !== undefined && calc.type === exports.TimeShiftType;
};
exports.timeShift = function (definition, name) {
    return function (sourceTable, windowedTable) { return exports.timeShiftTransform(definition, name, sourceTable, windowedTable); };
};
exports.timeShiftTransform = function (definition, name, sourceTable, windowedTable) {
    var calculation = definition.tableTransforms[name];
    if (!isTimeShift(calculation)) {
        throw new Error("Could not resolve TimeShift calculation with name: " + name);
    }
    var unit = dateUtils_1.momentStringFromDateTrunc(calculation.unit);
    var comparison = makeLegacyComparison(calculation);
    var currentRange = dateUtils_1.getDateRange(windowedTable);
    if (!currentRange || !unit) {
        return windowedTable;
    }
    var timestampAccessor = Accessor_1.accessorForReference(calculation.source);
    var outputFunc = makeOutputFunc(definition, name);
    var comparisonPoints = comparisonEngine_1.generateTimeBasedComparison(sourceTable, comparison, unit, currentRange, timestampAccessor, outputFunc);
    return comparisonEngine_1.interleaveComparisonPoints(windowedTable, comparisonPoints, timestampAccessor);
};
var makeOutputFunc = function (definition, calcName) {
    var obj = {};
    Object.entries(definition.schema).forEach(function (_a) {
        var key = _a[0], columnSchema = _a[1];
        if (EffectiveDefinition_1.isCalculatedColumnSchema(columnSchema) && columnSchema.calculation.name === calcName) {
            obj[key] = columnSchema.calculation.source;
        }
    });
    return mapperFromColumnRefs(obj);
};
var makeLegacyComparison = function (calculation) {
    var compareTo = calculation.unit;
    var numberOfPeriods = calculation.amount;
    return {
        type: 'HISTORICAL_COMPARISON',
        comparisonPeriod: compareTo,
        numberOfPeriods: numberOfPeriods,
        message: '',
    };
};
function mapperFromColumnRefs(obj) {
    return function (row) {
        var newRow = {};
        Object.entries(obj).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            newRow[key] = Accessor_1.accessorForReference(value)(row);
        });
        return newRow;
    };
}
exports.mapperFromColumnRefs = mapperFromColumnRefs;
//# sourceMappingURL=TimeShift.js.map